import {
  GET_UNITS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_UNITS,
  UPDATE_UNITS,
  DELETE_UNITS,
  CREATE_DEPARTMENT,
} from './actionType';

// common success
export const UnitsApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const UnitsApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Units = () => ({
  type: GET_UNITS,
});

export const CreateUnits = (data) => ({
  type: CREATE_UNITS,
  payload: { data },
});

export const UpdateUnits = (data) => ({
  type: UPDATE_UNITS,
  payload: { data },
});

export const DeleteUnits = (id) => ({
  type: DELETE_UNITS,
  payload: { id },
});

export const CreateDepartment = (data) => ({
  type: CREATE_DEPARTMENT,
  payload: { data },
});
